import { render } from "./payment-summary.vue?vue&type=template&id=1f88ca0f&scoped=true"
import script from "./payment-summary.vue?vue&type=script&lang=js"
export * from "./payment-summary.vue?vue&type=script&lang=js"

import "./payment-summary.vue?vue&type=style&index=0&id=1f88ca0f&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f88ca0f"]])

export default __exports__